export async function mergeAudioClips(base64List: string[], _enc: string): Promise<string> {
  const buffers = base64List.map(b64 => {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return arr.buffer;
  });
  const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
  const audioBuffers = await Promise.all(buffers.map(b => ctx.decodeAudioData(b.slice(0))));
  const total = audioBuffers.reduce((s, b) => s + b.length, 0);
  const channels = audioBuffers[0].numberOfChannels;
  const sampleRate = audioBuffers[0].sampleRate;
  const merged = ctx.createBuffer(channels, total, sampleRate);
  let offset = 0;
  for (const buf of audioBuffers) {
    for (let ch = 0; ch < channels; ch++) merged.getChannelData(ch).set(buf.getChannelData(ch), offset);
    offset += buf.length;
  }
  ctx.close();
  return URL.createObjectURL(audioBufferToWav(merged));
}

function audioBufferToWav(buffer: AudioBuffer): Blob {
  const nc = buffer.numberOfChannels, sr = buffer.sampleRate, nf = buffer.length;
  const bps = 2, ds = nf * nc * bps;
  const ab = new ArrayBuffer(44 + ds);
  const v = new DataView(ab);
  const ws = (o: number, s: string) => { for (let i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)); };
  ws(0, "RIFF"); v.setUint32(4, 36 + ds, true); ws(8, "WAVE"); ws(12, "fmt ");
  v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, nc, true);
  v.setUint32(24, sr, true); v.setUint32(28, sr * nc * bps, true);
  v.setUint16(32, nc * bps, true); v.setUint16(34, 16, true); ws(36, "data");
  v.setUint32(40, ds, true);
  let off = 44;
  for (let i = 0; i < nf; i++)
    for (let ch = 0; ch < nc; ch++) {
      const s = Math.max(-1, Math.min(1, buffer.getChannelData(ch)[i]));
      v.setInt16(off, s < 0 ? s * 0x8000 : s * 0x7FFF, true); off += 2;
    }
  return new Blob([ab], { type: "audio/wav" });
}